export const candidateSupportDomain = "sapia.ai/candidate-explainer"

export const ROLLBAR_TOKEN = process.env.REACT_APP_ROLLBAR_TOKEN
export const ENV = process.env.REACT_APP_ENVIRONMENT
